import React from 'react';
import { useNearMatch, useMissingFilters } from '../TileKit/hooks';
import './NearMissingMatch.scss';

const NearMatch = ({ match }) =>
  match ? <span>Near Match: {match}</span> : null;

const MissingFilters = ({ filters }) =>
  filters ? (
    <span>
      Missing:{' '}
      {filters.map((filter: string) => (
        <del key={filter}>{filter}</del>
      ))}
    </span>
  ) : null;

const BaseNearMissingMatch: React.VFC = () => {
  const nearMatch = useNearMatch(); // TODO confirm with product this can be removed
  const missingFilters = useMissingFilters();

  if (!nearMatch && !missingFilters) {
    return null;
  }

  const missingFiltersToShow = nearMatch ? 1 : 3;

  return (
    <>
      <NearMatch match={nearMatch} />
      <MissingFilters
        filters={missingFilters?.slice(0, missingFiltersToShow)}
      />
    </>
  );
};

const NearMissingMatch: React.VFC = () => (
  <div className="near-missing-match">
    <BaseNearMissingMatch />
  </div>
);

export default NearMissingMatch;
